const AVAILABLE_LANGUAGES = [
    // It always should be English the first language
    'en',
    'de',
    'es',
    'ru',
    'zh',
    'cs',
    'fr',
    'hr',
    'it',
    'hu',
    'nl',
    'pt',
    'sl',
    'tr',
    'ja',
    'th',
    'zh',
    'he',
    'ga',
];

module.exports = AVAILABLE_LANGUAGES;
